import MS_CONST from './msconst.js'

//-----------------------------------------------------------------------
//-----------------------------------------------------------------------
class msAxios {    
    constructor() {
        this.context = false;
    }
    //-----------------------------------------------------------------------
    setContext (context) {
        this.context = context;
    }
    //-----------------------------------------------------------------------
    getData (service, params, callback) {
        let url = MS_CONST.BACKEND_URL + service;        
        this.context.axios
        .get(url
           , { params: params }
        )
        .then(function(response) { 
            callback(false, response);
        })
        .catch(function(error) {
            callback(true, error);
        });
    }
    //-----------------------------------------------------------------------
}

export default {
    msAxios: new msAxios()
}